module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: ["wrapper"],
    style: _vm.wrapStyle
  }, [_c('div', {
    staticClass: ["dof-result"],
    style: {
      top: _vm.setPaddingTop,
      backgroundColor: _vm.bgColor_
    }
  }, [_c('image', {
    staticClass: ["result-image"],
    style: _vm.imgStyle,
    attrs: {
      "ariaHidden": true,
      "src": _vm.resultType.pic
    }
  }), _vm._t("text", [(_vm.resultType.content) ? _c('div', {
    staticClass: ["result-content"]
  }, [_c('text', {
    staticClass: ["content-text"]
  }, [_vm._v(_vm._s(_vm.resultType.content))]), (_vm.resultType.desc) ? _c('text', {
    staticClass: ["content-text", "content-desc"]
  }, [_vm._v(_vm._s(_vm.resultType.desc))]) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: ["result-button"],
    on: {
      "touchend": _vm.handleTouchEnd
    }
  }, [_vm._t("button", [(_vm.resultType.button) ? _c('dof-button', {
    attrs: {
      "size": "medium",
      "btnStyle": {
        width: 'auto',
        overflow: 'hidden',
        minWidth: '240px',
        maxWidth: '480px'
      },
      "textStyle": {
        textOverflow: 'none',
        maxWidth: '418px',
        marginLeft: 0,
        textAlign: 'center'
      },
      "text": _vm.resultType.button
    },
    on: {
      "dofButtonClicked": _vm.onClick
    }
  }) : _vm._e()]), (_vm.resultType.btnSubTitle) ? _c('text', {
    staticClass: ["btn-sub-text"],
    on: {
      "click": _vm.onSubClick
    }
  }, [_vm._v(_vm._s(_vm.resultType.btnSubTitle))]) : _vm._e()], 2)], 2)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-7d2d70f6!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-result/index.vue
// module id = 648
// module chunks = 0 1